import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as clipboard from '@attain-apps/fe/web/main/lib/clipboard'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as router from '@attain-apps/fe/web/main/lib/router'

import * as admin from '../../../admin'
import * as me from '../../../me'
import * as widgets from '../widgets'

import { Api } from './api.service'
import * as assistant from './assistant'
import { ClipboardItem } from './clipboard-item'
import * as effects from './effects'
import * as plugins from './plugins'
import type { TypeParams } from './types'

/**
 * Collection of {@link Entity} (based on
 * {@link ents.core.mosaic.Page})
 */
@ngCore.Injectable()
export class Collection extends ec.Collection<TypeParams> {
  public readonly assistant
  constructor() {
    const meFeature = ngCore.inject(me.Feature)

    super({
      api: ngCore.inject(Api),
      context$: meFeature.contexts.selectors.zoneContext.asObservable,
      identify: page => page.id,
      name: ec.Name.Predefined.MosaicPage,
      plugins: {
        additionalFactories: [
          new ds.table.ec.Factory(collection => ({
            rowConfig: ({ entity: page }) => ({
              iconsConfigs: [
                {
                  class: 'atn-icon atn-trash atn-red',
                  onClick: () => {
                    collection.plugins.editingPlugin.feature.actions.markForDeletion
                      .from(`Table.Row-${page.id}.Icons.Trash.Clicked`)
                      .dispatch({ id: page.id })
                  },
                },
              ],
              onClick: () => {
                const source = `Table.Row-${page.id}.Clicked`
                // Check if an edit session already exists
                if (
                  this.plugins.currentEntityPlugin.feature.selectors
                    .getEditedEntity()
                    .asSignal()
                ) {
                  // Discard the current edit session
                  this.plugins.editingPlugin.feature.actions.discard
                    .from(source)
                    .dispatch({ current: true })
                }

                // Start a new edit session
                this.plugins.editingPlugin.feature.actions.edit
                  .from(source)
                  .dispatch({ id: page.id })
              },
            }),
          })),
          new clipboard.Factory({
            clipboardService: ngCore.inject(clipboard.Service),
            pasteClassRef: ClipboardItem,
          }),
          new plugins.widgetPreview.Factory(),
        ],
      },
    })

    const previewPlugin = ngCore
      .inject(widgets.Collection)
      .plugins.lookup(widgets.plugins.preview.Plugin)
      .get()
    const _router = ngCore.inject(router.Router)
    const editingVariablesFeature = ngCore.inject(
      admin.editingVariables.Feature,
    )

    this.feature.registerEffects(
      effects.syncPageVariablesForEditing(this, editingVariablesFeature),
      effects.triggerWidgetsPreviews(this, previewPlugin),
      effects.pageBuilderNavigation(this, meFeature, _router),
    )

    this.assistant = new assistant.Feature(this)
  }
}
